var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _g, _g2, _g3, _g4, _g5, _g6, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpice5HailMary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB924",
    d: "M12.363 3.314a1.646 1.646 0 00-3.293 0v2.801a1.646 1.646 0 103.293 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#spice-5-hail-mary_svg__spice5-paint0_linear)",
    d: "M12.363 3.314a1.646 1.646 0 00-3.293 0v2.801a1.646 1.646 0 103.293 0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#spice-5-hail-mary_svg__spice5-paint1_linear)",
    d: "M10.71 3.553a1.655 1.655 0 00-1.655 1.654v4.05a1.5 1.5 0 01-.518 1.134L6.79 11.905l4.852 5.717.49-.476a.75.75 0 00.229-.538v-3.057l.002-.096V5.207a1.655 1.655 0 00-1.654-1.654"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#spice-5-hail-mary_svg__spice5-paint2_radial)",
    d: "M10.71 3.553a1.655 1.655 0 00-1.655 1.654v4.05a1.5 1.5 0 01-.518 1.134L6.79 11.905l4.852 5.717.49-.476a.75.75 0 00.229-.538v-3.057l.002-.096V5.207a1.655 1.655 0 00-1.654-1.654"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#spice-5-hail-mary_svg__spice5-paint3_linear)",
    d: "M10.71 3.553a1.655 1.655 0 00-1.655 1.654v4.05a1.5 1.5 0 01-.518 1.134L6.79 11.905l4.852 5.717.49-.476a.75.75 0 00.229-.538v-3.057l.002-.096V5.207a1.655 1.655 0 00-1.654-1.654"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB520",
    d: "M12.364 3.314a1.646 1.646 0 013.292 0v2.801a1.646 1.646 0 11-3.292 0z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#spice-5-hail-mary_svg__spice5-paint4_linear)",
    d: "M12.364 3.314a1.646 1.646 0 013.292 0v2.801a1.646 1.646 0 11-3.292 0z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#spice-5-hail-mary_svg__spice5-paint5_radial)",
    d: "M12.364 3.314a1.646 1.646 0 013.292 0v2.801a1.646 1.646 0 11-3.292 0z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#spice-5-hail-mary_svg__spice5-paint6_linear)",
    d: "M14.018 3.553c.913 0 1.654.74 1.654 1.654v4.05a1.5 1.5 0 00.517 1.134l1.747 1.514-4.852 5.717-.49-.476a.72.72 0 01-.228-.525v-3.07l-.003-.096V5.207c0-.914.741-1.654 1.655-1.654"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#spice-5-hail-mary_svg__spice5-paint7_radial)",
    d: "M14.018 3.553c.913 0 1.654.74 1.654 1.654v4.05a1.5 1.5 0 00.517 1.134l1.747 1.514-4.852 5.717-.49-.476a.72.72 0 01-.228-.525v-3.07l-.003-.096V5.207c0-.914.741-1.654 1.655-1.654"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#spice-5-hail-mary_svg__spice5-filter0_f)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "url(#spice-5-hail-mary_svg__spice5-paint8_linear)",
    strokeWidth: 0.113,
    d: "M18.2 12.857v5.94"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#spice-5-hail-mary_svg__spice5-filter1_f)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "url(#spice-5-hail-mary_svg__spice5-paint9_linear)",
    strokeWidth: 0.113,
    d: "M7.9 12.62l3.775 4.585"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#spice-5-hail-mary_svg__spice5-filter2_f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#spice-5-hail-mary_svg__spice5-paint10_linear)",
    d: "M15.3 5.124a.8.8 0 00-1.6 0v4.98c0 .551.231 1.077.638 1.448l.819.75a.89.89 0 001.22-1.3l-.688-.661c-.25-.24-.39-.57-.39-.916V5.123"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#spice-5-hail-mary_svg__spice5-filter3_f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#spice-5-hail-mary_svg__spice5-paint11_linear)",
    d: "M10.076 4.995a.8.8 0 011.6 0v9.378a1.713 1.713 0 01-3.205.843l-.481-.853a2.25 2.25 0 01.345-2.675l1.317-1.358a1.5 1.5 0 00.424-1.045z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#spice-5-hail-mary_svg__spice5-filter4_f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#spice-5-hail-mary_svg__spice5-paint12_linear)",
    d: "M15.053 3.517c.264-.218.237-.688-.062-1.05s-.755-.48-1.02-.262-.237.688.062 1.051c.298.362.755.48 1.02.261"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#spice-5-hail-mary_svg__spice5-filter5_f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFD75C",
    d: "M11.795 3.517c.264-.218.237-.689-.062-1.051-.299-.363-.755-.48-1.02-.262s-.237.689.062 1.051c.298.363.755.48 1.02.262"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#spice-5-hail-mary_svg__spice5-paint13_linear)",
    d: "M12.11 17.177l-4.716-5.62a.45.45 0 00-.615-.07l-.27.203a.75.75 0 00-.298.6v10.015a.188.188 0 00.308.144l5.535-4.638a.45.45 0 00.056-.634"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#spice-5-hail-mary_svg__spice5-paint14_linear)",
    d: "M12.11 17.177l-4.716-5.62a.45.45 0 00-.615-.07l-.27.203a.75.75 0 00-.298.6v10.015a.188.188 0 00.308.144l5.535-4.638a.45.45 0 00.056-.634"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#spice-5-hail-mary_svg__spice5-paint15_radial)",
    d: "M12.11 17.177l-4.716-5.62a.45.45 0 00-.615-.07l-.27.203a.75.75 0 00-.298.6v10.015a.188.188 0 00.308.144l5.535-4.638a.45.45 0 00.056-.634"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#spice-5-hail-mary_svg__spice5-paint16_linear)",
    d: "M12.11 17.177l-4.716-5.62a.45.45 0 00-.615-.07l-.27.203a.75.75 0 00-.298.6v10.015a.188.188 0 00.308.144l5.535-4.638a.45.45 0 00.056-.634"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#spice-5-hail-mary_svg__spice5-paint17_linear)",
    d: "M12.11 17.177l-4.716-5.62a.45.45 0 00-.615-.07l-.27.203a.75.75 0 00-.298.6v10.015a.188.188 0 00.308.144l5.535-4.638a.45.45 0 00.056-.634"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#spice-5-hail-mary_svg__spice5-paint18_linear)",
    d: "M12.617 17.178l4.715-5.62a.45.45 0 01.616-.07l.27.202a.75.75 0 01.297.6v10.015a.186.186 0 01-.211.186.2.2 0 01-.096-.042l-5.535-4.638a.45.45 0 01-.056-.633"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#spice-5-hail-mary_svg__spice5-paint19_radial)",
    d: "M12.617 17.178l4.715-5.62a.45.45 0 01.616-.07l.27.202a.75.75 0 01.297.6v10.015a.186.186 0 01-.211.186.2.2 0 01-.096-.042l-5.535-4.638a.45.45 0 01-.056-.633"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#spice-5-hail-mary_svg__spice5-paint20_linear)",
    d: "M12.617 17.178l4.715-5.62a.45.45 0 01.616-.07l.27.202a.75.75 0 01.297.6v10.015a.186.186 0 01-.211.186.2.2 0 01-.096-.042l-5.535-4.638a.45.45 0 01-.056-.633"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#spice-5-hail-mary_svg__spice5-paint21_linear)",
    d: "M12.617 17.178l4.715-5.62a.45.45 0 01.616-.07l.27.202a.75.75 0 01.297.6v10.015a.186.186 0 01-.211.186.2.2 0 01-.096-.042l-5.535-4.638a.45.45 0 01-.056-.633"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "spice-5-hail-mary_svg__spice5-paint0_linear",
    x1: 10.465,
    x2: 10.465,
    y1: 5.204,
    y2: 3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF9100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF9100",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "spice-5-hail-mary_svg__spice5-paint1_linear",
    x1: 9.577,
    x2: 9.577,
    y1: 3.844,
    y2: 16.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB725"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2882E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "spice-5-hail-mary_svg__spice5-paint3_linear",
    x1: 12.363,
    x2: 11.848,
    y1: 9.408,
    y2: 9.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD8200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD8200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "spice-5-hail-mary_svg__spice5-paint4_linear",
    x1: 13.465,
    x2: 13.465,
    y1: 6.235,
    y2: 2.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB7F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB7F00",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "spice-5-hail-mary_svg__spice5-paint6_linear",
    x1: 15.15,
    x2: 15.15,
    y1: 6.687,
    y2: 18.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBD2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2882E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "spice-5-hail-mary_svg__spice5-paint8_linear",
    x1: 18.7,
    x2: 18.7,
    y1: 12.261,
    y2: 19.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A69FB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#A578FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A69FB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "spice-5-hail-mary_svg__spice5-paint9_linear",
    x1: 7.811,
    x2: 12.344,
    y1: 11.922,
    y2: 17.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.214,
    stopColor: "#9867F8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9867F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776,
    stopColor: "#9867F8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "spice-5-hail-mary_svg__spice5-paint10_linear",
    x1: 15.341,
    x2: 15.341,
    y1: 4.324,
    y2: 18.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE563"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE563",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "spice-5-hail-mary_svg__spice5-paint11_linear",
    x1: 12.035,
    x2: 8.642,
    y1: 5.084,
    y2: 23.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD75A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD75A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "spice-5-hail-mary_svg__spice5-paint12_linear",
    x1: 13.971,
    x2: 15.722,
    y1: 2.205,
    y2: 4.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE563"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE563",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "spice-5-hail-mary_svg__spice5-paint13_linear",
    x1: 5.332,
    x2: 9.55,
    y1: 11.396,
    y2: 16.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6640A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D43FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "spice-5-hail-mary_svg__spice5-paint14_linear",
    x1: 9.851,
    x2: 9.213,
    y1: 14.237,
    y2: 14.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C2AC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C2AC4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "spice-5-hail-mary_svg__spice5-paint16_linear",
    x1: 5.893,
    x2: 6.533,
    y1: 16.945,
    y2: 16.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6236AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6236AE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "spice-5-hail-mary_svg__spice5-paint17_linear",
    x1: 9.598,
    x2: 9.369,
    y1: 20.027,
    y2: 19.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C6EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C6EFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "spice-5-hail-mary_svg__spice5-paint18_linear",
    x1: 17.426,
    x2: 13.938,
    y1: 14.05,
    y2: 21.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#945BCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#573EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "spice-5-hail-mary_svg__spice5-paint20_linear",
    x1: 14.876,
    x2: 15.285,
    y1: 14.238,
    y2: 14.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C2AC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C2AC4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "spice-5-hail-mary_svg__spice5-paint21_linear",
    x1: 15.129,
    x2: 15.31,
    y1: 20.028,
    y2: 19.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9469FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9469FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "spice-5-hail-mary_svg__spice5-filter0_f",
    width: 0.487,
    height: 6.315,
    x: 17.956,
    y: 12.67,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2268_6667",
    stdDeviation: 0.094
  })), /*#__PURE__*/React.createElement("filter", {
    id: "spice-5-hail-mary_svg__spice5-filter1_f",
    width: 4.237,
    height: 5.031,
    x: 7.669,
    y: 12.398,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2268_6667",
    stdDeviation: 0.094
  })), /*#__PURE__*/React.createElement("filter", {
    id: "spice-5-hail-mary_svg__spice5-filter2_f",
    width: 5.2,
    height: 10.462,
    x: 12.575,
    y: 3.199,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2268_6667",
    stdDeviation: 0.563
  })), /*#__PURE__*/React.createElement("filter", {
    id: "spice-5-hail-mary_svg__spice5-filter3_f",
    width: 6.227,
    height: 14.139,
    x: 6.573,
    y: 3.071,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2268_6667",
    stdDeviation: 0.563
  })), /*#__PURE__*/React.createElement("filter", {
    id: "spice-5-hail-mary_svg__spice5-filter4_f",
    width: 2.945,
    height: 3.032,
    x: 13.039,
    y: 1.345,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2268_6667",
    stdDeviation: 0.375
  })), /*#__PURE__*/React.createElement("filter", {
    id: "spice-5-hail-mary_svg__spice5-filter5_f",
    width: 2.945,
    height: 3.032,
    x: 9.781,
    y: 1.344,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_2268_6667",
    stdDeviation: 0.375
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spice-5-hail-mary_svg__spice5-paint2_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 -2.55667 3.83934 0 11.524 17.622)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C75E4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C75E4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spice-5-hail-mary_svg__spice5-paint5_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(2.4616 -2.43314 2.57008 2.60013 12.93 4.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#FFE051",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.907,
    stopColor: "#FFE051"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spice-5-hail-mary_svg__spice5-paint7_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 -2.55667 3.83934 0 13.203 17.622)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C75E4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C75E4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spice-5-hail-mary_svg__spice5-paint15_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-45 25.433 1.75) scale(6.491 2.35803)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8253FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8253FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "spice-5-hail-mary_svg__spice5-paint19_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(38.555 -10.203 29.535) scale(3.9861 2.09263)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D5BEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D5BEF",
    stopOpacity: 0
  })))));
}
export default __webpack_public_path__ + "static/spice-5-hail-mary.014eee74.svg";
export { SvgSpice5HailMary as ReactComponent };